module.exports = __webpack_public_path__ + "img/AsiaXpress.6cc84e4c.png";